import {
  MultiViewPage,
  MultiView,
} from 'approot/shared/layout/layout-multi-view';
import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { SettingsProps } from '../fill-in-blanks.constants';
import {
  FILL_IN_BLANKS_SENTENCE,
  FILL_IN_BLANKS_SENTENCES,
  FILL_IN_BLANKS_SENTENCE_DETAILS,
} from './fill-in-blanks-settings.constants';
import FillInBlanksSettingsSentences from './fill-in-blanks-settings-sentences';
import FillInBlanksSettingsSentence from './fill-in-blanks-settings-sentence';
import FillInBlanksSettingsAnswerDetail from './fill-in-blanks-settings-answer-detail';
import { FillInBlanksSettingsContextProvider } from './fill-in-blanks-settings.context';

const FillInBlanksSettings = (props: SettingsProps) => {
  const { closeDrawer } = useActivityBuilderContext();

  const { onCloseChildDrawer } = props;

  return (
    <MultiView>
      {multiviewProps => (
        <>
          <MultiViewPage
            index={FILL_IN_BLANKS_SENTENCES}
            {...multiviewProps}
            onClose={onCloseChildDrawer ? onCloseChildDrawer : closeDrawer}
            renderItem={() => (
              <FillInBlanksSettingsSentences
                {...props}
                {...multiviewProps}
                onCloseChildDrawer={onCloseChildDrawer}
              />
            )}
          />
          <MultiViewPage
            index={FILL_IN_BLANKS_SENTENCE}
            {...multiviewProps}
            renderItem={() => (
              <FillInBlanksSettingsSentence {...props} {...multiviewProps} />
            )}
          />
          <MultiViewPage
            index={FILL_IN_BLANKS_SENTENCE_DETAILS}
            {...multiviewProps}
            renderItem={() => (
              <FillInBlanksSettingsAnswerDetail
                {...props}
                {...multiviewProps}
              />
            )}
          />
        </>
      )}
    </MultiView>
  );
};

const FillInBlanksSettingsWrapper = (props: SettingsProps) => {
  return (
    <FillInBlanksSettingsContextProvider>
      <FillInBlanksSettings {...props} />
    </FillInBlanksSettingsContextProvider>
  );
};

export default FillInBlanksSettingsWrapper;
